export default {"src":"/_next/static/media/trustedSite.60cd2e64.svg","height":50,"width":120,"blurWidth":0,"blurHeight":0};